// extracted by mini-css-extract-plugin
export default {"link":"Link_link__pnRmO","disabled":"Link_disabled__Veu3n"};